<template>
  <div class="real-question">
    <div class="question-box" v-for="(item, index) in list" :key="index">
      <h4 class="question-title">{{ item.exam_name }}</h4>
      <div class="question-item" v-for="p in item.problem_detail" :key="p.problem_id">
        <span class="question-item-text" @click="toProblemInfo(p.problem_id)">{{ p.title }}</span>
        <span
          :class="['question-item-score', p.exist ? (p.score < 60 ? 'bg-color-yellow' : 'bg-color-green') : 'bg-color-red']">{{
            p.exist ? `${p.score}分` : '未做' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoiStatistics } from '@/api/xinAoTraining';
export default {
  name: "realQuestion",
  components: {},
  props: {
    type: { // [puji, tigao, noip]
      type: String,
      default: 'puji'
    },
  },
  data() {
    return {
      list: [],
      genre: this.type
    }
  },
  created() { },
  mounted() {
    this.getNoiStatistics();
  },
  watch: {
    type(newType) {
      // 当 type 变化时，重新加载数据或执行相关逻辑
      this.genre = newType;
      this.getNoiStatistics();
    },
  },
  methods: {
    getNoiStatistics() {
      getNoiStatistics({
        type: this.genre
      }).then(res => {
        if (res.status) {
          console.log(res);
          this.list = res.data.list;
        }
      })
    },
    toProblemInfo(problemId) {
      let types = ['puji', 'tigao', 'noip'];
      this.$router.push({
        name: 'singleProblemInfo', query: {
          problemId: problemId,
          activeTab: types.indexOf(this.genre) || 0
          // activeTab: 0
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.real-question {
  color: #FFF;
  display: flex;
  flex-wrap: wrap;
  padding: 0.8rem;
  background-color: rgba(255, 255, 255, .1);
  box-shadow: 0 1px 3px rgb(26 26 26 / 10%);
  border-radius: 4px;

  .question-box {
    background-color: #031832;
    border-radius: 0.4rem;
    padding: 1rem 1.2rem;
    width: 13.6rem;
    margin: 0.8rem;
    box-sizing: border-box;

    .question-title {
      margin-bottom: 0.4rem;
    }

    .question-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.4rem 0;

      .question-item-text {
        cursor: pointer;
        flex: 1;
        font-size: 0.74rem;

        &:hover {
          color: #409EFF;
        }
      }

      .question-item-score {
        font-size: 0.68rem;
        border-radius: 0.12rem;
        width: 2.4rem;
        text-align: center;
        margin-left: 0.8rem;

        &.bg-color-green {
          background-color: #52C41A;
        }

        &.bg-color-yellow {
          background-color: #FADB14;
        }

        &.bg-color-red {
          background-color: #F31E09;
        }
      }
    }
  }
}
</style>
